// extracted by mini-css-extract-plugin
export var browseMoreNav = "project-preview-grid-module--browseMoreNav--79b29 typography-module--small--2877f";
export var grid = "project-preview-grid-module--grid--47b6b";
export var headline = "project-preview-grid-module--headline--e2e22 typography-module--responsiveTitle3--2bebc";
export var root = "project-preview-grid-module--root--213a1";